import React from 'react'
import SearchIcon from 'shared/components/SearchIcon/SearchIcon'
import s from './HeaderSearchToggle.module.scss'

export default function HeaderSearchToggle({ onClick, isActive = false, ariaLabel = 'Search' }) {
	return (
		<button
			type="button"
			className={`${s.toggle} ${isActive ? s.toggle_active : ''}`}
			onClick={onClick}
			aria-label={ariaLabel}
			aria-expanded={isActive}
		>
			<SearchIcon className={s.icon} />
		</button>
	)
}
